const tabsButton = document.querySelector(".js-menu");
const links = document.querySelectorAll(".js-item");

let faqGroupsTop = [];
let activeLinks = [];

window.addEventListener("load", function () {
  let faqGroups = document.querySelectorAll(".js-content-item");

  if (faqGroups) {
    faqGroups.forEach((group, index) => {
      console.log(group.getBoundingClientRect().top + window.scrollY);
      faqGroupsTop.push({
        top: group.getBoundingClientRect().top + window.scrollY,

        id: index,
      });
    });
  }

  if (links) {
    links.forEach((link, index) => {
      if (index === 0) {
        link.classList.add("_active");
      }
      if (
        link.getAttribute("href") !== "#" &&
        !link.classList.contains("disabled")
      ) {
        activeLinks.push(link);
      }
    });
  }
});

let currentPos = 0;

window.addEventListener("scroll", function () {
  if (links) {
    let activeGroup = faqGroupsTop.filter((groupTop) => {
      return window.scrollY > groupTop.top;
    });

    links.forEach((item) => item.classList.remove("_active"));
    if (!activeGroup.length) {
      activeLinks[0].classList.add("_active");
    } else {
      activeLinks[activeGroup[activeGroup.length - 1].id].classList.add(
        "_active"
      );
    }
  }
});

if (links) {
  links.forEach((link, index) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      if (window.innerWidth < 768) {
        window.scrollTo({
          top:
            window.scrollY +
            document
              .querySelector(link.getAttribute("href"))
              .getBoundingClientRect().top +
            10,
          behavior: "smooth",
        });
      } else {
        window.scrollTo({
          top:
            window.scrollY +
            document
              .querySelector(link.getAttribute("href"))
              .getBoundingClientRect().top +
            10,
          behavior: "smooth",
        });
      }
    });
  });
}
